/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	FormSubmissionExportCsvQueryParams,
	FormSubmissionExportCsvResponse,
} from '../types/FormSubmissionExportCsv'

/**
 * GET /form-submissions.csv
 * @see backend/nexus/modules/Form/Http/Controllers/FormSubmissionController.php FormSubmissionController::exportCsv
 */
export async function formSubmissionExportCsv(
	params?: FormSubmissionExportCsvQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<FormSubmissionExportCsvResponse>> {
	return axiosInstance.get('/form-submissions.csv', { params, ...config })
}
